module.exports = __webpack_public_path__ + "static/media/13.e26563e4.jpg";